__turbopack_context__.v({
  "allowClicks": "RR5Qka_allowClicks",
  "bgNone": "RR5Qka_bgNone",
  "blurNone": "RR5Qka_blurNone",
  "container": "RR5Qka_container",
  "icon": "RR5Qka_icon",
  "loading": "RR5Qka_loading",
  "shimmer": "RR5Qka_shimmer",
  "showShimmer": "RR5Qka_showShimmer",
});
